import 'firebase/compat/auth'

import { PageNoAppbar } from '../../components/Page/PageNoAppbar'
import { LoginCard } from './LoginCard'

export default function LoginPage() {
  return (
    <PageNoAppbar title="Sign In">
      <LoginCard />
    </PageNoAppbar>
  )
}
